/* Wivya theme JS — vanilla, no framework */
(function () {
  'use strict';

  const T = window.theme || {};
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));

  /* ============ MONEY ============ */
  function formatMoney(cents) {
    const rupees = Math.round(cents) / 100;
    return '₹' + rupees.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }
  window.Wivya = { formatMoney };

  /* ============ TOAST ============ */
  let toastTimer = null;
  function toast(msg) {
    const el = $('#ToastEl');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('show'), 2400);
  }
  window.Wivya.toast = toast;

  /* ============ HERO REEL ============ */
  function initHero() {
    $$('[data-hero-reel]').forEach((root) => {
      const track = $('[data-hero-reel-track]', root);
      const slides = $$('[data-hero-slide]', root);
      const progress = $$('[data-hero-progress]', root);
      const copy = $('[data-hero-copy]', root);
      const name = $('[data-hero-name]', root);
      const fabric = $('[data-hero-fabric]', root);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!track || slides.length < 2) return;

      const realCount = slides.length - 1;
      let idx = 0;
      let timer = null;
      let paused = false;
      let touchTimer = null;
      let awaitingCloneReset = false;
      const warmedImages = new Set();

      function hydrateSlideMedia(index) {
        const slide = slides[index % slides.length];
        if (!slide) return;
        $$('source[data-srcset]', slide).forEach((source) => {
          source.srcset = source.dataset.srcset;
          delete source.dataset.srcset;
        });
        $$('img[data-src]', slide).forEach((image) => {
          image.src = image.dataset.src;
          image.fetchPriority = 'low';
          delete image.dataset.src;
        });
      }

      function slideImageUrl(index) {
        hydrateSlideMedia(index);
        const slide = slides[index % slides.length];
        const source = $('source[type="image/webp"]', slide);
        const image = $('img', slide);
        return (source && source.srcset && source.srcset.split(' ')[0]) || (image && (image.currentSrc || image.src));
      }

      function warmImage(index) {
        const url = slideImageUrl(index);
        if (!url || warmedImages.has(url)) return;
        warmedImages.add(url);
        const image = new Image();
        image.decoding = 'async';
        image.src = url;
      }

      function paintCopy(index, animate = true) {
        const slide = slides[index % realCount];
        if (name) name.textContent = slide.dataset.name || '';
        if (fabric) fabric.textContent = slide.dataset.fabric || '';
        if (copy && animate) {
          copy.classList.remove('is-entering');
          void copy.offsetWidth;
          copy.classList.add('is-entering');
        }
      }

      function paintProgress(index) {
        progress.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === (index % realCount));
        });
      }

      function resetCloneSilently() {
        awaitingCloneReset = false;
        track.classList.add('is-resetting');
        idx = 0;
        track.style.transform = 'translate3d(0, 0, 0)';
        paintProgress(0);
        void track.offsetHeight;
        requestAnimationFrame(() => track.classList.remove('is-resetting'));
      }

      function moveTo(next, animate = true) {
        idx = next;
        hydrateSlideMedia(idx);
        track.classList.toggle('is-resetting', !animate);
        if (animate) {
          void track.offsetHeight;
          track.classList.remove('is-resetting');
        }
        track.style.transform = 'translate3d(0, -' + (idx * (100 / slides.length)) + '%, 0)';
        paintCopy(idx, animate && idx !== 0);
        paintProgress(idx);
        if (idx === realCount) {
          awaitingCloneReset = true;
        }
        warmImage(idx + 1);
        warmImage(idx + 2);
      }

      function next() {
        if (!paused) moveTo(Math.min(idx + 1, realCount));
      }

      function start() {
        if (reduced) return;
        clearInterval(timer);
        timer = setInterval(next, 3500);
      }

      function pauseBriefly() {
        paused = true;
        clearTimeout(touchTimer);
        touchTimer = setTimeout(() => { paused = false; }, 3500);
      }

      progress.forEach((item, itemIndex) => {
        item.addEventListener('click', () => {
          moveTo(itemIndex);
          start();
        });
      });

      root.addEventListener('mouseenter', () => { paused = true; });
      root.addEventListener('mouseleave', () => { paused = false; });
      root.addEventListener('touchstart', pauseBriefly, { passive: true });
      track.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'transform' && awaitingCloneReset && idx === realCount) {
          resetCloneSilently();
        }
      });

      track.classList.add('is-resetting');
      track.style.transform = 'translate3d(0, 0, 0)';
      paintProgress(0);
      requestAnimationFrame(() => track.classList.remove('is-resetting'));
      warmImage(0);
      const firstImage = $('img', slides[0]);
      let hasStarted = false;
      const startWhenReady = () => {
        if (hasStarted) return;
        hasStarted = true;
        root.classList.add('is-hero-ready');
        const queueWarmup = window.requestIdleCallback || ((callback) => setTimeout(callback, 900));
        queueWarmup(() => warmImage(1));
        setTimeout(start, 5200);
      };
      if (firstImage && !firstImage.complete) {
        firstImage.addEventListener('load', startWhenReady, { once: true });
        setTimeout(startWhenReady, 1200);
      } else {
        startWhenReady();
      }
    });
  }

  function initHomeHeader() {
    if (!document.body.classList.contains('template-index')) return;
    const hero = $('[data-hero-reel]');
    let ticking = false;
    const setHeaderState = () => {
      document.body.classList.toggle('home-header-solid', window.scrollY > 24);
      if (hero) {
        const heroHeight = Math.max(1, hero.offsetHeight);
        const heroShell = hero.closest('.shopify-section');
        const nextShell = heroShell ? heroShell.nextElementSibling : null;
        const progress = Math.min(1, Math.max(0, window.scrollY / heroHeight));
        const cardOverlap = window.innerHeight * 0.13;
        const lift = Math.max(0, cardOverlap * Math.pow(1 - progress, 3));
        document.documentElement.style.setProperty('--hero-exit-y', (-progress * window.innerHeight * 0.12).toFixed(1) + 'px');
        document.documentElement.style.setProperty('--hero-copy-exit-y', (-progress * 42).toFixed(1) + 'px');
        document.documentElement.style.setProperty('--hero-next-y', lift.toFixed(1) + 'px');
        if (nextShell) nextShell.style.setProperty('--hero-next-y', lift.toFixed(1) + 'px');
      }
      ticking = false;
    };
    const requestState = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(setHeaderState);
      }
    };
    setHeaderState();
    window.addEventListener('scroll', requestState, { passive: true });
    window.addEventListener('resize', requestState);
  }

  /* ============ PRODUCT SLIDERS ============ */
  function initProductSliders() {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    $$('[data-product-slider]').forEach((root) => {
      const track = $('[data-product-slider-track]', root);
      const prev = $('[data-product-slider-prev]', root);
      const next = $('[data-product-slider-next]', root);
      const autoplay = (root.dataset.productSliderAuto === 'true' || root.dataset.productSliderStepAuto === 'true') && !reduced;
      if (!track) return;

      let timer = null;
      let paused = false;
      let touchTimer = null;

      if (autoplay && track.classList.contains('product-rail--marquee')) {
        function pauseMarqueeBriefly() {
          root.classList.add('is-paused');
          clearTimeout(touchTimer);
          touchTimer = setTimeout(() => root.classList.remove('is-paused'), 2600);
        }
        root.addEventListener('touchstart', pauseMarqueeBriefly, { passive: true });
        root.addEventListener('pointerdown', pauseMarqueeBriefly, { passive: true });
        return;
      }

      function getStep() {
        const card = $('.product-card', track);
        if (!card) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function go(direction) {
        const step = getStep();
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        if (direction > 0 && track.scrollLeft >= maxScroll) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        if (direction < 0 && track.scrollLeft <= 2) {
          track.scrollTo({ left: maxScroll, behavior: 'smooth' });
          return;
        }
        track.scrollBy({ left: step * direction, behavior: 'smooth' });
      }

      function start() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(() => {
          if (!paused) go(1);
        }, 2800);
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      function pauseBriefly() {
        paused = true;
        clearTimeout(touchTimer);
        touchTimer = setTimeout(() => { paused = false; }, 3600);
      }

      if (prev) prev.addEventListener('click', () => {
        pauseBriefly();
        go(-1);
      });
      if (next) next.addEventListener('click', () => {
        pauseBriefly();
        go(1);
      });
      root.addEventListener('mouseenter', () => { paused = true; });
      root.addEventListener('mouseleave', () => { paused = false; });
      root.addEventListener('touchstart', pauseBriefly, { passive: true });
      root.addEventListener('focusin', () => { paused = true; });
      root.addEventListener('focusout', () => { paused = false; });
      if (autoplay && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) start();
            else stop();
          });
        }, { rootMargin: '260px 0px' });
        observer.observe(root);
      } else if (autoplay) {
        const runWhenIdle = window.requestIdleCallback || ((callback) => setTimeout(callback, 1200));
        runWhenIdle(start);
      }
    });
  }

  /* ============ ACCORDIONS ============ */
  function initAccordions() {
    $$('[data-accordion]').forEach((root) => {
      $$('.accordion-head', root).forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.parentElement;
          const wasOpen = item.classList.contains('open');
          if (root.hasAttribute('data-accordion-single')) {
            $$('.accordion-item', root).forEach((i) => i.classList.remove('open'));
          }
          item.classList.toggle('open', !wasOpen);
          const icon = $('.accordion-icon', btn);
          if (icon) icon.textContent = !wasOpen ? '−' : '+';
        });
      });
    });
  }

  /* ============ PDP GALLERY + GIFT + PINCODE ============ */
  function initPdp() {
    const pdp = $('[data-pdp]');
    if (!pdp) return;

    // Gallery thumb click
    const mainImg = $('[data-pdp-main]', pdp);
    const mediaFrames = $$('[data-pdp-media]', pdp);
    const thumbs = $$('[data-pdp-thumb]', pdp);
    const galleryCount = $('[data-pdp-count]', pdp);
    const galleryDots = $$('[data-pdp-dot]', pdp);
    const mobileGalleryQuery = window.matchMedia('(max-width: 768px)');
    function publishThemeEvent(name, detail = {}) {
      window.dispatchEvent(new CustomEvent(name, { detail }));
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name.replace(/^wivya:/, 'wivya_'), detail);
        }
      } catch (_) {}
    }
    function updateGalleryCount(index) {
      if (galleryCount && thumbs.length > 1) {
        galleryCount.textContent = String(index + 1) + ' / ' + String(thumbs.length);
      }
      galleryDots.forEach((dot, dotIndex) => {
        dot.classList.toggle('active', dotIndex === index);
      });
    }
    let currentGalleryIndex = Math.max(0, thumbs.findIndex((t) => t.classList.contains('active')));
    let galleryTransitionTimer = 0;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function resetFrameMotion(frame) {
      frame.classList.remove('is-entering', 'is-exiting', 'enter-left', 'enter-right', 'exit-left', 'exit-right');
    }

    function activateGallery(index, options = {}) {
      if (!thumbs[index]) return;
      const direction = options.direction || (index >= currentGalleryIndex ? 'next' : 'prev');
      const currentFrame = mediaFrames.find((frame) => frame.classList.contains('active'));
      const mediaId = thumbs[index].dataset.mediaId;
      const nextFrame = mediaId
        ? mediaFrames.find((frame) => frame.dataset.pdpMedia === mediaId)
        : mediaFrames.find((frame) => frame.dataset.pdpMedia === `fallback-${index + 1}`);

      thumbs.forEach((t) => t.classList.remove('active'));
      thumbs[index].classList.add('active');
      updateGalleryCount(index);

      if (mobileGalleryQuery.matches && mainImg && nextFrame) {
        nextFrame.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
        currentGalleryIndex = index;
        return;
      }

      if (!nextFrame || nextFrame === currentFrame) {
        currentGalleryIndex = index;
        return;
      }

      window.clearTimeout(galleryTransitionTimer);
      mediaFrames.forEach(resetFrameMotion);

      const enteringClass = direction === 'next' ? 'enter-right' : 'enter-left';
      const exitingClass = direction === 'next' ? 'exit-left' : 'exit-right';

      if (prefersReducedMotion) {
        mediaFrames.forEach((frame) => {
          frame.classList.toggle('active', frame === nextFrame);
          const video = frame.querySelector('video');
          if (video && frame !== nextFrame) video.pause();
        });
        currentGalleryIndex = index;
        return;
      }

      if (currentFrame) {
        currentFrame.classList.remove('active');
        currentFrame.classList.add('is-exiting', exitingClass);
        const video = currentFrame.querySelector('video');
        if (video) video.pause();
      }

      nextFrame.classList.add('is-entering', enteringClass);
      nextFrame.getBoundingClientRect();
      window.requestAnimationFrame(() => {
        nextFrame.classList.add('active');
        nextFrame.classList.remove('is-entering', enteringClass);
      });

      galleryTransitionTimer = window.setTimeout(() => {
        mediaFrames.forEach((frame) => {
          if (frame !== nextFrame) frame.classList.remove('active');
          resetFrameMotion(frame);
        });
      }, 560);

      currentGalleryIndex = index;
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        activateGallery(index);
        const src = thumb.dataset.src;
        if (mainImg && src) mainImg.style.backgroundImage = 'url(' + src + ')';
      });
    });
    galleryDots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.pdpDotIndex || 0);
        if (thumbs[index]) {
          activateGallery(index);
          publishThemeEvent('wivya:pdp_gallery_dot_click', {
            index,
            productHandle: pdp.dataset.productHandle || ''
          });
        }
      });
    });
    updateGalleryCount(0);

    if (mainImg) {
      let scrollSyncTimer = 0;
      mainImg.addEventListener('scroll', () => {
        if (!mobileGalleryQuery.matches) return;
        window.clearTimeout(scrollSyncTimer);
        scrollSyncTimer = window.setTimeout(() => {
          const frames = $$('.pdp-media-frame', mainImg);
          if (!frames.length) return;
          const index = Math.max(0, Math.min(frames.length - 1, Math.round(mainImg.scrollLeft / Math.max(1, mainImg.clientWidth))));
          currentGalleryIndex = index;
          thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('active', thumbIndex === index));
          updateGalleryCount(index);
        }, 80);
      }, { passive: true });
    }

    function warmGalleryImages() {
      if (!mainImg) return;
      const galleryImages = $$('.pdp-media-frame img', mainImg);
      galleryImages.forEach((img, index) => {
        setTimeout(() => {
          img.loading = 'eager';
          img.fetchPriority = index === 0 ? 'high' : 'auto';
          const preload = new Image();
          preload.decoding = 'async';
          preload.fetchPriority = index === 0 ? 'high' : 'auto';
          if (img.sizes) preload.sizes = img.sizes;
          if (img.srcset) preload.srcset = img.srcset;
          preload.src = img.currentSrc || img.src;
          if (img.dataset.zoomSrc) {
            setTimeout(() => {
              const zoomPreload = new Image();
              zoomPreload.decoding = 'async';
              zoomPreload.src = img.dataset.zoomSrc;
            }, 360 + index * 120);
          }
        }, index * 90);
      });
    }

    const firstGalleryImage = $('.pdp-media-frame.active img', mainImg);
    const queueGalleryWarmup = () => {
      const idle = window.requestIdleCallback || ((callback) => setTimeout(callback, 400));
      idle(warmGalleryImages, { timeout: 1400 });
    };
    if (firstGalleryImage && !firstGalleryImage.complete) {
      firstGalleryImage.addEventListener('load', queueGalleryWarmup, { once: true });
      setTimeout(queueGalleryWarmup, 1800);
    } else {
      queueGalleryWarmup();
    }

    const lightboxImages = $$('.pdp-media-frame img', mainImg).map((img, index) => ({
      index,
      src: img.dataset.zoomSrc || img.currentSrc || img.src,
      fallbackSrc: img.currentSrc || img.src,
      alt: img.alt || ''
    }));
    let lightbox = null;
    let lightboxImg = null;
    let lightboxCounter = null;
    let lightboxIndex = 0;
    let lightboxScale = 1;
    let lightboxStartX = 0;
    let lightboxStartY = 0;

    function currentLightboxIndex() {
      const activeImage = $('.pdp-media-frame.active img', mainImg);
      if (!activeImage) return 0;
      const index = $$('.pdp-media-frame img', mainImg).indexOf(activeImage);
      return Math.max(0, index);
    }

    function applyLightboxScale() {
      if (!lightboxImg) return;
      lightboxImg.style.transform = `scale(${lightboxScale})`;
      lightboxImg.classList.toggle('is-zoomed', lightboxScale > 1);
    }

    function renderLightboxImage(index) {
      if (!lightboxImg || !lightboxImages.length) return;
      lightboxIndex = (index + lightboxImages.length) % lightboxImages.length;
      const item = lightboxImages[lightboxIndex];
      lightboxScale = 1;
      lightboxImg.src = item.src || item.fallbackSrc;
      lightboxImg.alt = item.alt;
      if (lightboxCounter) lightboxCounter.textContent = `${lightboxIndex + 1} / ${lightboxImages.length}`;
      applyLightboxScale();
      publishThemeEvent('wivya:pdp_lightbox_view', {
        index: lightboxIndex,
        productHandle: pdp.dataset.productHandle || ''
      });
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('has-pdp-lightbox');
    }

    function openLightbox(index = currentLightboxIndex()) {
      if (!lightboxImages.length) return;
      if (!lightbox) {
        lightbox = document.createElement('div');
        lightbox.className = 'pdp-lightbox';
        lightbox.setAttribute('aria-hidden', 'true');
        lightbox.innerHTML = `
          <div class="pdp-lightbox__bar">
            <span class="pdp-lightbox__counter"></span>
            <div class="pdp-lightbox__tools">
              <button type="button" data-pdp-lightbox-zoom-out aria-label="Zoom out">−</button>
              <button type="button" data-pdp-lightbox-zoom-in aria-label="Zoom in">+</button>
              <button type="button" data-pdp-lightbox-close aria-label="Close image viewer">×</button>
            </div>
          </div>
          <button type="button" class="pdp-lightbox__nav pdp-lightbox__nav--prev" data-pdp-lightbox-prev aria-label="Previous image">‹</button>
          <div class="pdp-lightbox__stage" data-pdp-lightbox-stage>
            <img class="pdp-lightbox__image" alt="">
          </div>
          <button type="button" class="pdp-lightbox__nav pdp-lightbox__nav--next" data-pdp-lightbox-next aria-label="Next image">›</button>
        `;
        document.body.appendChild(lightbox);
        lightboxImg = $('.pdp-lightbox__image', lightbox);
        lightboxCounter = $('.pdp-lightbox__counter', lightbox);
        const lightboxClose = $('[data-pdp-lightbox-close]', lightbox);
        const lightboxPrev = $('[data-pdp-lightbox-prev]', lightbox);
        const lightboxNext = $('[data-pdp-lightbox-next]', lightbox);
        const lightboxZoomIn = $('[data-pdp-lightbox-zoom-in]', lightbox);
        const lightboxZoomOut = $('[data-pdp-lightbox-zoom-out]', lightbox);
        const lightboxStage = $('[data-pdp-lightbox-stage]', lightbox);
        if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
        if (lightboxPrev) lightboxPrev.addEventListener('click', () => renderLightboxImage(lightboxIndex - 1));
        if (lightboxNext) lightboxNext.addEventListener('click', () => renderLightboxImage(lightboxIndex + 1));
        if (lightboxZoomIn) lightboxZoomIn.addEventListener('click', () => {
          lightboxScale = Math.min(2.6, Number((lightboxScale + 0.35).toFixed(2)));
          applyLightboxScale();
        });
        if (lightboxZoomOut) lightboxZoomOut.addEventListener('click', () => {
          lightboxScale = Math.max(1, Number((lightboxScale - 0.35).toFixed(2)));
          applyLightboxScale();
        });
        if (lightboxStage) lightboxStage.addEventListener('click', () => {
          lightboxScale = lightboxScale > 1 ? 1 : 1.7;
          applyLightboxScale();
        });
        lightbox.addEventListener('click', (event) => {
          if (event.target === lightbox) closeLightbox();
        });
        lightbox.addEventListener('touchstart', (event) => {
          if (!event.touches || event.touches.length !== 1) return;
          lightboxStartX = event.touches[0].clientX;
          lightboxStartY = event.touches[0].clientY;
        }, { passive: true });
        lightbox.addEventListener('touchend', (event) => {
          if (!event.changedTouches || event.changedTouches.length !== 1) return;
          if (lightboxScale > 1) return;
          const dx = event.changedTouches[0].clientX - lightboxStartX;
          const dy = event.changedTouches[0].clientY - lightboxStartY;
          if (Math.abs(dx) < 44 || Math.abs(dx) < Math.abs(dy)) return;
          renderLightboxImage(dx < 0 ? lightboxIndex + 1 : lightboxIndex - 1);
        }, { passive: true });
        document.addEventListener('keydown', (event) => {
          if (!lightbox || !lightbox.classList.contains('is-open')) return;
          if (event.key === 'Escape') closeLightbox();
          if (event.key === 'ArrowRight') renderLightboxImage(lightboxIndex + 1);
          if (event.key === 'ArrowLeft') renderLightboxImage(lightboxIndex - 1);
        });
      }
      renderLightboxImage(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('has-pdp-lightbox');
    }

    if (mainImg && thumbs.length > 1) {
      let startX = 0;
      let startY = 0;
      mainImg.addEventListener('touchstart', (e) => {
        if (!e.touches || e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      mainImg.addEventListener('touchend', (e) => {
        if (mobileGalleryQuery.matches) return;
        if (!e.changedTouches || e.changedTouches.length !== 1) return;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy)) return;
        const current = Math.max(0, thumbs.findIndex((t) => t.classList.contains('active')));
        const next = dx < 0 ? Math.min(thumbs.length - 1, current + 1) : Math.max(0, current - 1);
        if (next !== current) activateGallery(next, { direction: dx < 0 ? 'next' : 'prev' });
      }, { passive: true });
      mainImg.addEventListener('click', (e) => {
        if (e.target.closest('button, a, video, iframe, model-viewer')) return;
        const current = Math.max(0, thumbs.findIndex((t) => t.classList.contains('active')));
        const imageIndex = currentLightboxIndex();
        openLightbox(imageIndex);
        publishThemeEvent('wivya:pdp_lightbox_open', {
          index: imageIndex,
          galleryIndex: current,
          productHandle: pdp.dataset.productHandle || ''
        });
      });
    }

    // Blouse property selector
    const blouseHidden = $('[data-blouse-input]', pdp);
    const blouseLabel = $('[data-blouse-label]', pdp);
    const stitchedNote = $('[data-blouse-stitched-note]', pdp);
    $$('[data-blouse-option]', pdp).forEach((opt) => {
      opt.addEventListener('click', () => {
        $$('[data-blouse-option]', pdp).forEach((o) => o.classList.remove('active'));
        opt.classList.add('active');
        const val = opt.dataset.blouseOption;
        if (blouseHidden) blouseHidden.value = val === 'stitched' ? 'Stitched (included)' : 'Unstitched (0.8m piece)';
        if (blouseLabel) blouseLabel.textContent = opt.dataset.label;
        if (stitchedNote) stitchedNote.hidden = val !== 'stitched';
      });
    });

    // Gift note toggle
    const giftToggle = $('[data-gift-toggle]', pdp);
    const giftBody = $('[data-gift-body]', pdp);
    const giftInput = $('[data-gift-input]', pdp);
    const giftHidden = $('[data-gift-hidden]', pdp);
    const giftCount = $('[data-gift-count]', pdp);
    if (giftToggle) {
      giftToggle.addEventListener('click', () => {
        const on = giftToggle.classList.toggle('on');
        giftToggle.setAttribute('aria-checked', on ? 'true' : 'false');
        if (giftBody) giftBody.hidden = !on;
        if (!on && giftInput) {
          giftInput.value = '';
          if (giftHidden) giftHidden.value = '';
          if (giftCount) giftCount.textContent = '0';
        }
      });
    }
    if (giftInput && giftHidden) {
      giftInput.addEventListener('input', () => {
        giftHidden.value = giftInput.value;
        if (giftCount) giftCount.textContent = String(giftInput.value.length);
      });
    }

    // Pincode (client-side mock; replace with real serviceability API later)
    const pinInput = $('[data-pin-input]', pdp);
    const pinBtn = $('[data-pin-btn]', pdp);
    const pinMsg = $('[data-pin-msg]', pdp);
    function checkPin() {
      if (!pinInput || !pinMsg) return;
      const v = pinInput.value.trim();
      if (!/^\d{6}$/.test(v)) {
        pinMsg.textContent = 'Enter a valid 6-digit pincode.';
        pinMsg.className = 'pincode-msg err';
        return;
      }
      const d = new Date(Date.now() + 4 * 86400000);
      const eta = d.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short' });
      pinMsg.textContent = 'Estimated delivery by ' + eta + ' · Dispatches in 24-48 hours';
      pinMsg.className = 'pincode-msg ok';
    }
    if (pinBtn) pinBtn.addEventListener('click', checkPin);
    if (pinInput) pinInput.addEventListener('input', () => {
      pinInput.value = pinInput.value.replace(/\D/g, '').slice(0, 6);
    });
    if (pinInput) pinInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); checkPin(); } });

    const stickyAddToCart = $('[data-sticky-add-to-cart]', pdp);
    if (stickyAddToCart) stickyAddToCart.addEventListener('click', () => {
      const atcBtn = $('[data-add-to-cart]', pdp);
      if (atcBtn && !atcBtn.disabled) atcBtn.click();
    });
    const stickyBuyNow = $('[data-sticky-buy-now]', pdp);
    if (stickyBuyNow) stickyBuyNow.addEventListener('click', () => {
      const buyBtn = $('[data-buy-now="true"]', pdp);
      if (buyBtn && !buyBtn.disabled) buyBtn.click();
    });
  }

  /* ============ AJAX CART ============ */
  async function fetchCart() {
    const r = await fetch(T.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }

  async function addToCart(formData) {
    const r = await fetch(T.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to cart.');
    }
    return r.json();
  }

  async function changeCart(line, quantity) {
    const r = await fetch(T.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not update your bag.');
    }
    return r.json();
  }

  async function updateCartNote(note) {
    const r = await fetch(T.routes.cart_url + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note })
    });
    return r.json();
  }

  /* ============ CART DRAWER ============ */
  function renderCart(cart) {
    const drawer = $('#CartDrawer');
    if (!drawer) return;
    const count = cart.item_count;
    const subtotal = cart.items_subtotal_price;
    const threshold = T.free_shipping_threshold || 500000;
    const shipping = (subtotal >= threshold || subtotal === 0) ? 0 : 14900;
    const showGift = drawer.dataset.giftLine === 'true';
    const discount = Number(cart.total_discount || 0);
    const total = (discount > 0 ? Number(cart.total_price || Math.max(0, subtotal - discount)) : subtotal) + shipping;

    // Update count badges
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
    $('[data-cart-count-words]', drawer).textContent = count + ' item' + (count !== 1 ? 's' : '');

    // Shipping progress
    const progress = $('[data-shipping-progress]', drawer);
    if (progress) {
      if (count === 0 || subtotal >= threshold) {
        progress.hidden = true;
      } else {
        const remain = threshold - subtotal;
        progress.hidden = false;
        progress.innerHTML = 'Add <strong>' + formatMoney(remain) + '</strong> more for free shipping.';
      }
    }

    // Items
    const itemsEl = $('[data-cart-items]', drawer);
    if (itemsEl) {
      if (count === 0) {
        itemsEl.innerHTML = `
          <div class="cart-empty">
            <div class="ic-wrap">
              <svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="width:26px;height:26px"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>
            </div>
            <h4>Your bag awaits its first drape.</h4>
            <p>Twenty-five new arrivals, every one ready to gift.</p>
            <button class="btn btn-accent" data-cart-close>Start Browsing</button>
          </div>`;
      } else {
        itemsEl.innerHTML = cart.items.map((item, idx) => {
          const img = item.featured_image && item.featured_image.url ? item.featured_image.url : '';
          const blouse = (item.properties && item.properties['Blouse']) || '';
          const note = (item.properties && item.properties['Gift Note']) || '';
          const sub = [item.product_type, blouse].filter(Boolean).join(' · ');
          return `
            <div class="cart-item" data-line="${idx + 1}">
              <div class="cart-img" style="background-image:url(${img})"></div>
              <div class="cart-meta">
                <div class="name">${escapeHtml(item.product_title)}</div>
                <div class="sub">${escapeHtml(sub)}</div>
                ${note ? `<div class="gift-pill">✦ Gift wrapped</div>` : ''}
                <div class="cart-bottom">
                  <div class="qty">
                    <button data-qty-change="-1" aria-label="Decrease">−</button>
                    <span>${item.quantity}</span>
                    <button data-qty-change="1" aria-label="Increase">+</button>
                  </div>
                  <div class="price">${formatMoney(item.final_line_price)}</div>
                </div>
                <button class="cart-remove" data-cart-remove>Remove</button>
              </div>
            </div>`;
        }).join('');
      }
    }

    // Foot totals
    const foot = $('[data-cart-foot]', drawer);
    if (foot) {
      foot.hidden = count === 0;
      $('[data-cart-subtotal]', foot).textContent = formatMoney(subtotal);
      $('[data-cart-shipping]', foot).textContent = shipping === 0 ? 'Free' : formatMoney(shipping);
      $('[data-cart-total]', foot).textContent = formatMoney(total);
      const discountRow = $('[data-cart-discount-row]', foot);
      const discountValue = $('[data-cart-discount]', foot);
      if (discountRow && discountValue) {
        discountRow.hidden = discount <= 0;
        discountValue.textContent = discount > 0 ? '-' + formatMoney(discount) : '';
      }
      const noteField = $('[data-cart-note]', foot);
      if (noteField && document.activeElement !== noteField) noteField.value = cart.note || '';
    }

    bindCartItemHandlers();
  }

  function bindCartItemHandlers() {
    const drawer = $('#CartDrawer');
    $$('[data-line]', drawer).forEach((row) => {
      const line = parseInt(row.dataset.line, 10);
      $$('[data-qty-change]', row).forEach((b) => {
        b.addEventListener('click', async () => {
          if (b.disabled) return;
          const current = parseInt($('.qty span', row).textContent, 10);
          const delta = parseInt(b.dataset.qtyChange, 10);
          const next = Math.max(0, current + delta);
          b.disabled = true;
          try {
            const cart = await changeCart(line, next);
            renderCart(cart);
          } catch (err) {
            toast(err.message || 'Could not update your bag.');
          } finally {
            b.disabled = false;
          }
        });
      });
      const removeButton = $('[data-cart-remove]', row);
      if (removeButton) removeButton.addEventListener('click', async (e) => {
        const button = e.currentTarget;
        if (button.disabled) return;
        button.disabled = true;
        try {
          const cart = await changeCart(line, 0);
          renderCart(cart);
        } catch (err) {
          toast(err.message || 'Could not remove this item.');
        } finally {
          button.disabled = false;
        }
      });
    });
    $$('[data-upsell-add]', drawer).forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', async () => {
        const id = btn.dataset.upsellAdd;
        if (!id) return;
        const label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding';
        try {
          const fd = new FormData();
          fd.append('id', id);
          fd.append('quantity', '1');
          await addToCart(fd);
          renderCart(await fetchCart());
          toast('Added to your bag');
        } catch (err) {
          toast(err.message || 'Could not add item.');
        } finally {
          btn.disabled = false;
          btn.textContent = label;
        }
      });
    });
    const noteField = $('[data-cart-note]', drawer);
    if (noteField && noteField.dataset.bound !== 'true') {
      noteField.dataset.bound = 'true';
      let noteTimer = null;
      noteField.addEventListener('input', () => {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(async () => {
          try {
            await updateCartNote(noteField.value.trim());
            toast('Gift note saved');
          } catch {
            toast('Could not save note yet');
          }
        }, 700);
      });
    }
    $$('[data-cart-close]', drawer).forEach((b) => b.addEventListener('click', closeCart));
  }

  function openCart() {
    $('#CartScrim').classList.add('open');
    $('#CartDrawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    $('#CartScrim').classList.remove('open');
    $('#CartDrawer').classList.remove('open');
    document.body.style.overflow = '';
  }
  window.Wivya.openCart = openCart;
  window.Wivya.closeCart = closeCart;

  function initCart() {
    if (!$('#CartDrawer')) return;
    $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); }));
    const cartScrim = $('#CartScrim');
    if (cartScrim) cartScrim.addEventListener('click', closeCart);
    $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeCart));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });
    fetchCart().then(renderCart).catch(() => {});
  }

  /* ============ PDP ADD-TO-CART ============ */
  function buildCartEventDetail(source) {
    const value = Math.round((parseInt(source.dataset.productPrice || '0', 10) || 0)) / 100;
    const currency = source.dataset.productCurrency || 'INR';
    const contentId = source.dataset.variantId || source.dataset.productId || '';
    return {
      productTitle: source.dataset.productTitle || 'Item',
      productUrl: window.location.href,
      value,
      currency,
      content_ids: contentId ? [contentId] : undefined,
      content_type: 'product'
    };
  }

  function trackAddToCart(detail) {
    window.dispatchEvent(new CustomEvent('wivya:add_to_cart', { detail }));
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('wivya_add_to_cart', detail);
      }
    } catch (_) {}
  }

  function initAtcForm() {
    const form = $('[data-pdp-form]');
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const buyNow = e.submitter && e.submitter.dataset.buyNow === 'true';
      const fd = new FormData(form);
      const btn = e.submitter || form.querySelector('button[type="submit"]');
      const origText = btn ? btn.innerHTML : '';
      const eventDetail = buildCartEventDetail(form);
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
      try {
        await addToCart(fd);
        const cart = await fetchCart();
        renderCart(cart);
        const name = form.dataset.productTitle || 'Item';
        toast(name + ' added to your bag');
        trackAddToCart(eventDetail);
        if (buyNow) {
          window.dispatchEvent(new CustomEvent('wivya:online_checkout_intent', { detail: eventDetail }));
          try {
            if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
              window.Shopify.analytics.publish('wivya_online_checkout_intent', eventDetail);
            }
          } catch (_) {}
          window.location.href = '/checkout';
        } else {
          openCart();
        }
      } catch (err) {
        toast(err.message || 'Could not add to bag.');
      } finally {
        if (btn) { btn.disabled = false; btn.innerHTML = origText; }
      }
    });
  }

  function initCardAtcForms() {
    $$('[data-card-atc-form]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        const original = btn ? btn.textContent : '';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding';
        }
        try {
          await addToCart(new FormData(form));
          const cart = await fetchCart();
          renderCart(cart);
          trackAddToCart(buildCartEventDetail(form));
          toast((form.dataset.productTitle || 'Item') + ' added');
          openCart();
        } catch (err) {
          toast(err.message || 'Could not add to bag.');
        } finally {
          if (btn) {
            btn.disabled = false;
            btn.textContent = original;
          }
        }
      });
    });
  }

  /* ============ WHATSAPP ORDER CTA ============ */
  function initWhatsappOrderTracking() {
    $$('[data-whatsapp-order]').forEach((link) => {
      link.addEventListener('click', () => {
        const detail = {
          productTitle: link.dataset.productTitle || '',
          productUrl: link.dataset.productUrl || window.location.href
        };
        window.dispatchEvent(new CustomEvent('wivya:whatsapp_order_click', { detail }));
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('wivya_whatsapp_order_click', detail);
          }
        } catch (_) {}
        try {
          if (typeof window.fbq === 'function') {
            window.fbq('trackCustom', 'WhatsAppOrderClick', detail);
          }
        } catch (_) {}
      });
    });
  }

  /* ============ NEWSLETTER (no backend wiring needed; Shopify form submit posts to /contact) ============ */
  function initNewsletter() {
    $$('[data-newsletter]').forEach((form) => {
      form.addEventListener('submit', () => {
        // Shopify's contact form handles the POST. Just show success on the next page.
      });
    });
  }

  /* ============ WISHLIST (localStorage v1) ============ */
  const WISH_KEY = 'wivya_wishlist_v1';
  function getWishlist() {
    try { return new Set(JSON.parse(localStorage.getItem(WISH_KEY) || '[]')); }
    catch { return new Set(); }
  }
  function saveWishlist(set) {
    localStorage.setItem(WISH_KEY, JSON.stringify([...set]));
    updateWishCount();
  }
  function updateWishCount() {
    const n = getWishlist().size;
    $$('[data-wish-count]').forEach((el) => {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }
  function initWishlist() {
    updateWishCount();
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wish]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.wish;
      const name = btn.dataset.wishName || 'Item';
      const set = getWishlist();
      if (set.has(handle)) {
        set.delete(handle);
        btn.classList.remove('on');
        toast('Removed from wishlist');
      } else {
        set.add(handle);
        btn.classList.add('on');
        toast(name + ' saved to wishlist');
      }
      saveWishlist(set);
    });
    // Mark all wish buttons that are saved
    const set = getWishlist();
    $$('[data-wish]').forEach((b) => {
      if (set.has(b.dataset.wish)) b.classList.add('on');
    });
  }

  /* ============ FILTER SUBMIT ON CHANGE ============ */
  function initFilters() {
    const form = $('[data-filter-form]');
    if (!form) return;
    const panel = $('.filters');
    const scrim = $('.filter-scrim');
    const toggleFilters = () => {
      const willOpen = !(panel && panel.classList.contains('open'));
      if (panel) panel.classList.toggle('open', willOpen);
      if (scrim) scrim.classList.toggle('open', willOpen);
      document.body.classList.toggle('filters-open', willOpen);
    };
    const closeFilters = () => {
      if (panel) panel.classList.remove('open');
      if (scrim) scrim.classList.remove('open');
      document.body.classList.remove('filters-open');
    };
    form.addEventListener('change', (e) => {
      const target = e.target;
      if (target && target.matches('input[type="checkbox"], select')) form.submit();
    });
    $$('[data-mobile-filter-toggle]').forEach((btn) => {
      btn.addEventListener('click', toggleFilters);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeFilters(); });
  }

  /* ============ MOBILE MENU ============ */
  function initMobileMenu() {
    const menu = $('#MobileMenu');
    const scrim = $('#MobileMenuScrim');
    if (!menu || !scrim) return;

    function openMenu() {
      menu.classList.add('open');
      scrim.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const closeButton = $('[data-mobile-menu-close]', menu);
      if (closeButton) closeButton.focus();
    }

    function closeMenu() {
      menu.classList.remove('open');
      scrim.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    $$('[data-mobile-menu-open]').forEach((b) => {
      b.addEventListener('click', (e) => {
        e.preventDefault();
        openMenu();
      });
    });
    $$('[data-mobile-menu-close]').forEach((b) => b.addEventListener('click', closeMenu));
    scrim.addEventListener('click', closeMenu);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeMenu();
    });
    $$('.mobile-menu a', menu).forEach((a) => a.addEventListener('click', closeMenu));
  }

  /* ============ PRODUCT HEADER ============ */
  function initProductHeader() {
    if (!document.body.classList.contains('template-product')) return;

    const setHeaderState = () => {
      document.body.classList.toggle('product-header-solid', window.scrollY > 24);
    };
    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  }

  function initFloatingProductVideo() {
    if (!document.body.classList.contains('template-product')) return;
    const pdp = $('[data-pdp]');
    const widget = $('[data-floating-video]');
    const openBtn = $('[data-floating-video-open]', widget || document);
    const closeBtn = $('[data-floating-video-close]', widget || document);
    const reopenBtn = $('[data-floating-video-reopen]');
    const modal = $('[data-floating-video-modal]');
    const modalClose = $('[data-floating-video-modal-close]', modal || document);
    const previewVideo = $('.floating-video-media', widget || document);
    const modalVideo = $('.floating-video-modal-media', modal || document);
    if (!widget || !openBtn || !modal) return;

    widget.classList.remove('is-hidden');
    if (reopenBtn) reopenBtn.hidden = true;
    sessionStorage.removeItem('wivyaFloatingVideoHidden');

    let dragging = false;
    let didDrag = false;
    let startX = 0;
    let startY = 0;
    let startLeft = 0;
    let startBottom = 0;
    let hasCustomPosition = false;
    let previewLoaded = false;
    let modalLoaded = false;

    function safePlay(video) {
      if (!video || typeof video.play !== 'function') return;
      const playResult = video.play();
      if (playResult && typeof playResult.catch === 'function') playResult.catch(() => {});
    }

    function attachVideo(video, shouldPlay = false) {
      if (!video) return;
      if (!video.src && video.dataset.src) {
        video.src = video.dataset.src;
        video.load();
      }
      if (shouldPlay) safePlay(video);
    }

    function loadPreviewVideo() {
      if (previewLoaded) return;
      previewLoaded = true;
      attachVideo(previewVideo, !widget.classList.contains('is-hidden'));
    }

    loadPreviewVideo();

    function clampPosition(left, bottom) {
      const rect = widget.getBoundingClientRect();
      const margin = 10;
      const maxLeft = Math.max(margin, window.innerWidth - rect.width - margin);
      const maxBottom = Math.max(margin, window.innerHeight - rect.height - margin);
      return {
        left: Math.min(Math.max(margin, left), maxLeft),
        bottom: Math.min(Math.max(margin, bottom), maxBottom)
      };
    }

    function setPosition(left, bottom) {
      const next = clampPosition(left, bottom);
      widget.style.setProperty('--float-x', `${next.left}px`);
      widget.style.setProperty('--float-y', `${next.bottom}px`);
    }

    function openModal() {
      if (didDrag) return;
      loadPreviewVideo();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (modalVideo && previewVideo) {
        if (!modalLoaded) {
          modalLoaded = true;
          attachVideo(modalVideo, false);
        }
        modalVideo.currentTime = previewVideo.currentTime || 0;
        modalVideo.muted = false;
        safePlay(modalVideo);
      }
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (modalVideo) modalVideo.pause();
      safePlay(previewVideo);
    }

    openBtn.addEventListener('pointerdown', (event) => {
      dragging = true;
      didDrag = false;
      startX = event.clientX;
      startY = event.clientY;
      const rect = widget.getBoundingClientRect();
      startLeft = rect.left;
      startBottom = window.innerHeight - rect.bottom;
      widget.classList.add('is-dragging');
      if (openBtn.setPointerCapture) openBtn.setPointerCapture(event.pointerId);
    });

    openBtn.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (Math.abs(dx) + Math.abs(dy) > 6) didDrag = true;
      if (didDrag) hasCustomPosition = true;
      setPosition(startLeft + dx, startBottom - dy);
    });

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      widget.classList.remove('is-dragging');
      if (openBtn.releasePointerCapture) openBtn.releasePointerCapture(event.pointerId);
      setTimeout(() => { didDrag = false; }, 0);
    }

    openBtn.addEventListener('pointerup', endDrag);
    openBtn.addEventListener('pointercancel', endDrag);
    openBtn.addEventListener('click', openModal);

    if (closeBtn) closeBtn.addEventListener('click', (event) => {
      event.stopPropagation();
      widget.classList.add('is-hidden');
      if (reopenBtn) reopenBtn.hidden = false;
      if (previewVideo) previewVideo.pause();
    });
    if (reopenBtn) reopenBtn.addEventListener('click', () => {
      widget.classList.remove('is-hidden');
      reopenBtn.hidden = true;
      loadPreviewVideo();
      safePlay(previewVideo);
    });
    if (modalClose) modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    window.addEventListener('resize', () => {
      if (!hasCustomPosition) return;
      const rect = widget.getBoundingClientRect();
      setPosition(rect.left, window.innerHeight - rect.bottom);
    });
  }

  function publishStorefrontSignal(name, detail = {}) {
    window.dispatchEvent(new CustomEvent(name, { detail }));
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name.replace(/^wivya:/, 'wivya_'), detail);
      }
    } catch (_) {}
  }

  function initBehaviorSignals() {
    $$('.product-card-link').forEach((link) => {
      link.addEventListener('click', () => {
        const card = link.closest('[data-product-handle]');
        publishStorefrontSignal('wivya:product_card_open', {
          productHandle: card ? (card.dataset.productHandle || '') : '',
          productUrl: link.getAttribute('href') || '',
          pagePath: window.location.pathname
        });
      });
    });
    $$('.shop-now-shortcuts a, .discovery-strip a').forEach((link) => {
      link.addEventListener('click', () => {
        publishStorefrontSignal('wivya:collection_shortcut_click', {
          label: link.textContent.trim(),
          destination: link.getAttribute('href') || '',
          pagePath: window.location.pathname
        });
      });
    });
  }

  function initSafeInternalLinks() {
    const safeTargets = {
      '/collections': '/collections/all',
      '/collections/organza': '/pages/shop-by-fabric#organza',
      '/collections/organza-stories': '/pages/shop-by-fabric#organza',
      '/collections/featherlight-organza': '/pages/shop-by-fabric#organza',
      '/collections/organza-tissue': '/pages/shop-by-fabric#organza-tissue',
      '/collections/tissue-silk': '/pages/shop-by-fabric#tissue-shimmer',
      '/collections/tissue-tales': '/pages/shop-by-fabric#tissue-shimmer',
      '/collections/liquid-tissue': '/pages/shop-by-fabric#tissue-shimmer',
      '/collections/crunchy-silk': '/pages/shop-by-fabric#crunchy',
      '/collections/structured-silk': '/pages/shop-by-fabric#crunchy',
      '/collections/fancy-weaves': '/pages/shop-by-fabric#fancy-weaves',
      '/collections/chiffon': '/pages/shop-by-fabric',
      '/collections/soft-drape': '/pages/shop-by-fabric',
      '/collections/heritage': '/collections/heritage-reserve',
      '/collections/heritage-bridal': '/collections/heritage-reserve',
      '/collections/wedding-guest': '/pages/shop-by-occasion#wedding-guest',
      '/collections/the-wedding-edit': '/pages/shop-by-occasion#wedding-guest',
      '/collections/sangeet': '/pages/shop-by-occasion#wedding-guest',
      '/collections/engagement': '/pages/shop-by-occasion#wedding-guest',
      '/collections/wedding-worthy': '/pages/shop-by-occasion#wedding-guest',
      '/collections/bridesmaid': '/pages/shop-by-occasion#bridesmaid',
      '/collections/reception': '/pages/shop-by-occasion#reception',
      '/collections/festive': '/pages/shop-by-occasion#festive',
      '/collections/festive-light': '/pages/shop-by-occasion#festive',
      '/collections/family-functions': '/pages/shop-by-occasion#festive',
      '/collections/festive-favourites': '/pages/shop-by-occasion#festive',
      '/collections/evening-celebrations': '/collections/evening-statements',
      '/collections/minimal-elegance': '/collections/the-pastel-edit?sort_by=manual',
      '/collections/gift-worthy': '/pages/shop-by-occasion#gifting',
      '/collections/anniversary-gifts': '/pages/shop-by-occasion#gifting',
      '/collections/birthday-gifts': '/pages/shop-by-occasion#gifting',
      '/pages/gifting': '/pages/shop-by-occasion#gifting',
      '/collections/blush': '/pages/shop-by-colour#pinks-roses',
      '/collections/antique-gold': '/pages/shop-by-colour#golds-warmth',
      '/collections/gold-tones': '/pages/shop-by-colour#golds-warmth',
      '/collections/sage': '/pages/shop-by-colour#greens',
      '/collections/indigo': '/pages/shop-by-colour#blues-purples',
      '/collections/jewel-tones': '/pages/shop-by-colour#blues-purples',
      '/collections/ivory': '/pages/shop-by-colour#neutrals-dark',
      '/collections/mocha': '/pages/shop-by-colour#neutrals-dark',
      '/collections/neutral-sarees': '/pages/shop-by-colour#neutrals-dark',
      '/collections/pastels': '/pages/shop-by-colour#pastels',
      '/collections/colour': '/pages/shop-by-colour',
      '/collections/everyday-luxury': '/pages/shop-by-price#6000-8000',
      '/collections/bestsellers': '/pages/shop-by-price#bestsellers'
    };

    const normalizePath = (href) => {
      try {
        return new URL(href, window.location.origin).pathname;
      } catch (_) {
        return '';
      }
    };

    $$('a[href]').forEach((link) => {
      const path = normalizePath(link.getAttribute('href'));
      const replacement = safeTargets[path];
      if (!replacement) return;
      link.setAttribute('href', replacement);
      link.dataset.safeResolved = 'true';
    });
  }

  function initViewportVars() {
    const setVars = () => {
      const viewport = window.visualViewport;
      const visibleHeight = viewport ? viewport.height : window.innerHeight;
      const offset = Math.max(0, window.innerHeight - visibleHeight - (viewport ? viewport.offsetTop : 0));
      document.documentElement.style.setProperty('--visible-viewport-bottom', `${offset.toFixed(1)}px`);
    };
    setVars();
    window.addEventListener('resize', setVars, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setVars, { passive: true });
      window.visualViewport.addEventListener('scroll', setVars, { passive: true });
    }
  }

  /* ============ UTIL ============ */
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  /* ============ BOOT ============ */
  function boot() {
    initSafeInternalLinks();
    initHero();
    initAccordions();
    initPdp();
    initCart();
    initAtcForm();
    initCardAtcForms();
    initWhatsappOrderTracking();
    initNewsletter();
    initWishlist();
    initFilters();
    initMobileMenu();
    initHomeHeader();
    initProductSliders();
    initProductHeader();
    initFloatingProductVideo();
    initBehaviorSignals();
    initViewportVars();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
